// @core/api/endpoints/license/check_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckLicenseRequest,
  CheckLicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Check license
 * Performs check operation on license.
 */
export async function CheckLicense(
  data: CheckLicenseRequest,
  options?: RequestOptions
): Promise<CheckLicenseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/check_license`;
  const requestOptions = options;
  return client.post<CheckLicenseResponse>(requestPath, data, requestOptions);
}
